exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cashback-widget {\n  background-color: #FFD600;\n  border-radius: 32px;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: \"Inter\", sans-serif;\n  text-decoration: none !important;\n}\n.cashback-widget__title {\n  display: flex;\n  flex-direction: column;\n  color: #181D27;\n  font-size: 13px;\n}\n.cashback-widget__title b {\n  font-size: 16px;\n  font-weight: 800;\n}\n.cashback-widget__price {\n  display: flex;\n  color: #181D27;\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 10px;\n  margin-left: auto;\n}\n.cashback-widget__price b {\n  font-weight: 700;\n}", ""]);

// exports
